<template>
  <custom-dialog class="firmware-task-add-device-dialog" :appendToBody="true" width="1400px" :fullscreen="true" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body" :style="{ height: bodyHeight + 'px' }">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button type="primary" @click="addAllDevice"><i class="icon icon-add"></i>{{ $t('dms_firmwareTask_addDevice_dialog.tjqbsb') }}</el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('dms_firmwareTask_addDevice_dialog.jshModemSNcpSN')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <el-form-item style="float: right">
            <switch-button :link="$refs.container"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onSearch" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('dms_firmwareTask_addDevice_dialog.zhlxsj')">
            <custom-date-picker style="width: 100%" v-model="formSearch.timer" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="beforeToday"></custom-date-picker>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_addDevice_dialog.chan_pin_xing_hao')">
            <custom-select
              url="productCodeSelectList"
              v-model="formSearch.productCode"
              :listener="formSearch.websiteCode"
              :params="{ websiteCode: formSearch.websiteCode }"
              :props="{ label: 'productCode', value: 'productCode' }"
              width="100%"
            ></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_addDevice_dialog.shou_hou_gong_si')">
            <el-input v-model="formSearch.afterServiceName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_addDevice_dialog.dai_li_gong_si')">
            <el-input v-model="formSearch.agentCoName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_addDevice_dialog.zu_lin_fang')">
            <el-input v-model="formSearch.customerName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_addDevice_dialog.xiang_mu')">
            <el-input v-model="formSearch.locationName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_addDevice_dialog.xygjbb')">
            <el-input v-model="formSearch.fwVersion"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_firmwareTask_addDevice_dialog.ji_qi_ban_ben')">
            <el-input v-model="formSearch.machineVersion"></el-input>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table
          ref="table"
          :data="deviceList"
          height="100%"
          :loading="isLoading"
          tableCode="select_device"
          :slots="['taskDesc', 'isMatchFwVersion']"
          :filterArr="data.taskStrategy === '2' ? ['firmwareVersion', 'action'] : ['action']"
          @column="setColumn"
          @input="selectionChange($event, 'selectedData')"
          @selectionAll="selectionAll($event, 'selectedData')"
          @filter="filterChange"
          @sort="sortChange"
          :rowClassName="tableRowClassName"
        >
          <el-table-column type="selection" :selectable="checkboxSelect" width="40" slot="prepose"></el-table-column>
          <template v-slot:isMatchFwVersion="scope">
            <div :class="scope.row.isMatchFwVersion === 1 ? 'green' : 'red'">
              {{ getDicValue('isynergy_cloud_approval_result', scope.row.isMatchFwVersion) }}
            </div>
          </template>
          <template v-slot:taskDesc="scope">
            <el-popover placement="bottom" width="200" trigger="hover" v-if="scope.row.taskDesc">
              {{ scope.row.taskDesc }}
              <i class="icon icon-banbenxinxi" slot="reference" style="color: #2aafff; font-size: 16px"></i>
            </el-popover>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveDevice" v-repeat="10000">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';

export default {
  mixins: [resetFormSearchMixins],
  props: {
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
  },
  components: {},
  computed: {},
  data() {
    return {
      visible: true,
      bodyHeight: document.body.clientHeight - 100,

      selectedData: [],
      // addDetailType：任务详情类型：0：用户选中的部分设备， 1：添加全部设备，2：添加全部modem
      addDetailType: 0,
      // 第三步
      formSearch: {
        search: '',
        taskName: '',
        pageSize: 50,
        pageNum: 1,
        taskId: '',
        isAssociate: 0, // 是否关联 0不关联 1关联
        // 筛选
        bodyNum: '',

        bigCustomerId: '',
        firmwareId: '',

        // 高级搜索
        //  售后公司
        afterServiceName: '',
        // 代理公司
        agentCoName: '',
        // 租赁方
        customerName: '',
        timer: [],
        lastOnlineStartTime: '',
        lastOnlineEndTime: '',
        productCode: '',
        locationName: '',
        fwVersion: '',
        machineVersion: '',
      },
      isLoading: false,
      totalRows: null,
      deviceList: [],
    };
  },
  created() {
    this.formSearch.taskId = this.data.taskId;
  },
  mounted() {
    this.initDialog();
    window.addEventListener('resize', this.onResize, false);
    // this.getTableColumn();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize, false);
  },
  methods: {
    tableRowClassName(data) {
      const row = data.row;
      return row.isMatchFwVersion ? '' : 'forbidden';
    },
    checkboxSelect(row) {
      return this.data.serviceType !== '3' || !!row.isMatchFwVersion;
    },
    onResize() {
      this.bodyHeight = document.body.clientHeight - 100;
    },
    addAllDevice() {
      if (this.addDetailType === 0) {
        this.$refs.table.$emit('toggleAllSelection');
      }
      this.addDetailType = 1;
    },
    // 表头的全选CheckBox
    selectionAll(selection) {
      if (!selection.length) {
        this.addDetailType = 0;
      }
      // else {
      //   this.addDetailType = 1;
      // }
    },
    // 初始化
    initDialog: function () {
      // if (this.data.taskStrategy === '2') {
      //   // 延期不要现有固件版本号
      //   this.getTableColumn(['firmwareVersion']);
      // } else {
      //   this.getTableColumn();
      // }
      this.getdeviceList();
    },
    // 表格选中变更
    selectionChange: function (val, name) {
      // 如果topic controlMode设置设备是1那就是单选
      if (val.length > 1 && this.data.controlMode === 1) {
        this.$refs.table.$refs.tb1.clearSelection();
        const select = val.pop();
        this.$refs.table.$refs.tb1.toggleRowSelection(select);
        this[name] = [select];
        // this.name = [];
        // this[name] = val;
      } else {
        // this.name = [];
        this[name] = val;
      }
    },
    // 第一步选择合同
    getdeviceList: function () {
      this.formSearch.lastOnlineStartTime = this.formSearch.timer ? this.formSearch.timer[0] : '';
      this.formSearch.lastOnlineEndTime = this.formSearch.timer ? this.formSearch.timer[1] : '';
      this.$getJSON(apis.commandTaskDevicePage, this.formSearch).then((res) => {
        if (this.addDetailType === 1) {
          this.$refs.table.$emit('toggleAllSelection');
        }
        this.isLoading = false;
        this.deviceList = res.data.list;
        this.totalRows = res.data.total;

      });
    },
    // 保存编辑分组
    saveDevice: function () {
      // this.tableSelect
      if (!this.selectedData.length) {
        const msg = this.$t('dms_firmwareTask_addDevice_dialog.qing_xuan_ze_she_bei');
        this.$message.error(msg);
        return;
      }
      const params = {};
      // addDetailType：任务详情类型：0：用户选中的部分设备， 1：添加全部设备，2：添加全部modem
      if (this.addDetailType === 1) {
        // 选择全部设备
        params.devices = [];
        params.taskId = this.data.taskId;
        params.addDetailType = this.addDetailType;

        this.$postJSON(`${apis.commandTaskDetailSaveSelectedAll}`, Object.assign(params, this.formSearch)).then(() => {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          this.$emit('success');
          this.visible = false;
        });
      } else {
        // 非选择全部设备
        // 暂时写死
        this.selectedData.forEach((item) => {
          item.commandType = '1';
          item.oldResourceVersion = item.fwVersion;
        });
        params.devices = this.selectedData;
        params.taskId = this.data.taskId;
        params.addDetailType = this.addDetailType;

        this.$postJSON(`${apis.commandTaskDetailSave}`, params).then(() => {
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          this.$emit('success');
          this.visible = false;
        });
      }


    },
    onSearch() {
      this.onPageChange({ page: 1 });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getdeviceList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.firmware-task-add-device-dialog {
  .green {
    color: #67c23a;
  }

  .red {
    color: #f56c6c;
  }
  .forbidden {
    background: #f6f8fa;
  }
  .el-dialog {
    width: 1400px;
  }
  .dialog-body {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    display: flex;
    flex-direction: column;
    // .table-bd {
    //   height: auto !important;
    // }
  }
}
</style>
